<template>
  <v-container>
    <v-card>
      <v-row align="center" class="py-1 px-2" no-gutters>
        <v-col cols="12">
          <v-breadcrumbs class="px-2" :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
      </v-row>
      <v-card-title>{{ $vuetify.lang.translator("viraName") }}</v-card-title>
      <v-card-text>{{ $vuetify.lang.translator("viraIntro") }}</v-card-text>
      <v-card-title>{{
        $vuetify.lang.translator("contactInformation")
      }}</v-card-title>
      <v-card-text>
        <p>
          <v-icon class="mx-2">fa-phone</v-icon>
          <a href="tel:+989100212029">09100212029</a>
        </p>
        <p><v-icon class="mx-2">fa-fax</v-icon>32235306-034</p>
        <p>
          <v-icon class="mx-2">fa-at</v-icon>
          <a href="mailto:virakavir.co@gmail.com" target="_blank"
            >ViraKavir.Co@gmail.com</a
          >
        </p>
        <p>
          <v-icon class="mx-2">fa-globe</v-icon>
          <a href="https://www.virakavir.com" target="_blank"
            >www.ViraKavir.com</a
          >
        </p>
      </v-card-text>
      <v-card-title>{{ $vuetify.lang.translator("address") }}</v-card-title>
      <v-card-text>
        <v-icon class="mx-2">fa-map-marked-alt</v-icon>
        {{ $vuetify.lang.translator("viraAddress") }}
      </v-card-text>
      <v-card-title>{{ $vuetify.lang.translator("programmer") }}</v-card-title>
      <v-card-text>
        <v-icon class="mx-2">fa-user</v-icon
        >{{ $vuetify.lang.translator("aliMHZ")
        }}<v-btn
          href="https://www.linkedin.com/in/ali-mohammad-hossein-zadeh/"
          target="_blank"
          class="mr-2"
          x-small
          icon
          ><v-icon class="mx-2">fab fa-linkedin</v-icon></v-btn
        >
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "About",
  data: () => ({
    breadcrumbsItems: []
  }),
  created() {
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("system")
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("about"),
      to: { name: "About" }
    });
  }
};
</script>
